// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DatePicker_wrapper__5Hkev","dayPickerInput":"DatePicker_dayPickerInput__2qlC-"};